import { useCallback, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { isNil } from 'lodash';
import { useOnClickOutside } from 'taboola-ultimate-ui';
import { IconWithCaption } from '../IconWithCaption/IconWithCaption';
import styles from './PopupSideItem.module.scss';

const classNameBuilder = classnames.bind(styles);

export const PopupSideItem = ({
    item,
    collapsed,
    handler,
    dropdownComponent: DropdownComponent,
    dropdownProps,
    open: openControlled,
    popupClassName,
    active,
    dataAutomationId,
    ariaLabel,
}) => {
    const ref = useRef();
    const [open, setOpen] = useState(false);
    const onClick = useCallback(() => {
        if (handler) {
            handler();
        }
        setOpen(prev => !prev);
    }, [handler]);

    useOnClickOutside(ref, () => setOpen(false));

    return (
        <div className={styles['container']} data-automation={dataAutomationId}>
            <IconWithCaption
                item={item}
                active={(active || openControlled) ?? open}
                collapsed={collapsed}
                onClick={onClick}
                className={classNameBuilder({ open })}
                showHintOnActive={!isNil(active)}
                ariaLabel={ariaLabel}
            />
            {open && (
                <div className={classNameBuilder('dropdown-container', popupClassName)} ref={ref}>
                    {DropdownComponent && <DropdownComponent {...dropdownProps} open close={() => setOpen(false)} />}
                </div>
            )}
        </div>
    );
};
